import { Select } from 'antd';
import { type FC, useMemo } from 'react';
import type { SelectProps } from 'antd/lib/select';
import { TRANSLATED_COMMODITY } from '@/utils/commodities';
import { Commodity } from '@enmon/commons/lib/shared';
import { filterOption, filterSort } from '../utils';

export interface CommoditiesSelectProps extends SelectProps<Commodity> {
  onChange?: (value: Commodity | null) => void;
}

export const CommoditiesSelect: FC<CommoditiesSelectProps> = props => {
  const { onChange, ...propsToPass } = props;
  const commodityOptions =
    useMemo(() => Object.values(Commodity).map(type => ({ value: type, label: TRANSLATED_COMMODITY[type] })), []) ?? [];

  return (
    <Select
      allowClear
      showSearch={{
        filterOption,
        filterSort,
      }}
      placeholder="Select commodity"
      options={commodityOptions}
      popupMatchSelectWidth={false}
      onChange={onChange}
      onClear={() => onChange?.(null)}
      {...propsToPass}
    />
  );
};
